import { render, staticRenderFns } from "./StructureToolbar.vue?vue&type=template&id=2fcf337b&scoped=true&"
import script from "./StructureToolbar.vue?vue&type=script&lang=js&"
export * from "./StructureToolbar.vue?vue&type=script&lang=js&"
import style0 from "./StructureToolbar.vue?vue&type=style&index=0&id=2fcf337b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcf337b",
  null
  
)

export default component.exports